import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { UserService } from './user.service';



@Injectable({
    providedIn: 'root'
  })

export class PermissionListResolverService implements Resolve<any>{

    constructor(
        private authService: AuthService,
        private userService: UserService,
         ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any>{
        return this.userService.getUserPermission(this.authService.getUserLoggedIn())
    }

}